import { ParsedUrlQuery } from 'querystring';

export function getRentalTerm(query: ParsedUrlQuery) {
    if (query['rental_term']) {
        return query['rental_term'];
    }

    return '';
}
